import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ClientType } from '@shared/types/client-type';
import { computed } from 'vue';

interface Props {
  type: ClientType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientBadge',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
  type: ClientType;
}



const isCompany = computed(() => props.type === ClientType.company);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["client-badge", _unref(isCompany) ? 'company' : 'person'])
  }, _toDisplayString(_unref(isCompany) ? 'Ю' : 'Ф'), 3))
}
}

})